import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MdClose } from 'react-icons/md';
import { FaUserPlus } from 'react-icons/fa';

function AddStudentModal({ isOpen, onClose, onAddStudent }) {
  const [studentId, setStudentId] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!studentId.trim()) return;
    setLoading(true);
    try {
      await onAddStudent(studentId.trim());
      setStudentId('');
      // onAddStudent in parent calls setIsAddStudentOpen(false) on success
    } catch {
      // error toasted by parent
    } finally {
      setLoading(false);
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center px-4"
          style={{ background: "rgba(0,0,0,0.72)", backdropFilter: "blur(10px)" }}
          onClick={e => { if (e.target === e.currentTarget) onClose(); }}
        >
          <motion.div
            initial={{ opacity: 0, y: 14, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 8, scale: 0.97 }}
            transition={{ duration: 0.2, ease: [0.16, 1, 0.3, 1] }}
            className="w-full max-w-sm rounded-2xl overflow-hidden"
            style={{ background: "#12151f", border: "1px solid rgba(255,255,255,0.09)", boxShadow: "0 32px 64px rgba(0,0,0,0.6)" }}
          >
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-5"
              style={{ borderBottom: "1px solid rgba(255,255,255,0.07)" }}>
              <div className="flex items-center gap-2.5">
                <FaUserPlus size={14} style={{ color: "rgba(255,255,255,0.50)" }} />
                <h2 className="text-base font-bold text-white">Add Student</h2>
              </div>
              <button onClick={onClose}
                className="p-1.5 rounded-lg transition-all"
                style={{ color: "rgba(255,255,255,0.30)" }}
                onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,0.07)"; e.currentTarget.style.color = "rgba(255,255,255,0.70)"; }}
                onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "rgba(255,255,255,0.30)"; }}>
                <MdClose size={16} />
              </button>
            </div>

            {/* Body */}
            <form onSubmit={handleSubmit} className="p-6 space-y-4">
              <div>
                <label className="block text-xs font-semibold uppercase tracking-widest mb-2"
                  style={{ color: "rgba(255,255,255,0.30)" }}>
                  Student ID
                </label>
                <input
                  type="text"
                  value={studentId}
                  onChange={e => setStudentId(e.target.value)}
                  placeholder="Enter student ID…"
                  autoFocus
                  className="w-full rounded-xl px-4 py-2.5 text-sm text-white placeholder-white/20 outline-none transition-all"
                  style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.09)", caretColor: "white" }}
                  onFocus={e => e.target.style.border = "1px solid rgba(255,255,255,0.28)"}
                  onBlur={e => e.target.style.border = "1px solid rgba(255,255,255,0.09)"}
                />
              </div>

              <div className="flex justify-end gap-2 pt-1">
                <button type="button" onClick={onClose}
                  className="px-4 py-2.5 rounded-xl text-sm font-medium transition-all"
                  style={{ background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.08)", color: "rgba(255,255,255,0.50)" }}>
                  Cancel
                </button>
                <button type="submit" disabled={!studentId.trim() || loading}
                  className="px-5 py-2.5 rounded-xl text-sm font-bold text-white transition-all"
                  style={{
                    background: studentId.trim() && !loading
                      ? "linear-gradient(135deg, #1d4ed8 0%, #4f46e5 100%)"
                      : "rgba(255,255,255,0.06)",
                    color: studentId.trim() && !loading ? "white" : "rgba(255,255,255,0.25)",
                    cursor: studentId.trim() && !loading ? "pointer" : "not-allowed",
                    boxShadow: studentId.trim() && !loading ? "0 4px 16px rgba(29,78,216,0.30)" : "none",
                  }}>
                  {loading ? "Adding…" : "Add Student"}
                </button>
              </div>
            </form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default AddStudentModal;
